import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /settings */
export const settingsRoutes: RouteObject = {
  path: 'settings',
  handle: handle('settings'),
  lazy: () => import('./SettingsPage').then((m) => ({ Component: m.SettingsPage })),
};
